/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://3wmhzm6qijbpbdmshalghp6uom.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:c6c4f3ee-901b-4c98-870f-d77fd1019617",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_wY94s59UK",
    "aws_user_pools_web_client_id": "4jf07s3808ilui15qi02nil8mn",
    "oauth": {
        "domain": "auth.test.vduracfg.com",
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": "https://test.vduracfg.com/,http://localhost:3000/,https://gen2-dev.d3myh77zd5mupc.amplifyapp.com/",
        "redirectSignOut": "https://test.vduracfg.com/,http://localhost:3000/,https://gen2-dev.d3myh77zd5mupc.amplifyapp.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "vsysconfigurator-bom-respositoryb0918-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
